
import { Component, Mixins } from 'vue-mixin-decorator';
import BasePage from './BasePage.vue';
import { ValidationObserver } from 'vee-validate';
import {
  PostBacklogIssuesRequest,
  PostEmailInquiryReplyRequest
} from '@/apis/store-core';

@Component
export default class SupportPage extends Mixins<BasePage>(BasePage) {
  /* form variables */
  private company = '';
  private companyFurigana = '';
  private firstName = '';
  private lastName = '';
  private phone = '';
  private email = '';
  private emailConfirmation = '';
  private queryType = '';
  private queryBody = '';
  private consent = false;
  private queryTypes: any = {};
  private queryTypeItems: any[] = [];
  private confirmDialog: boolean = false;

  /* this.$refs 参照で型エラーになるため
    https://logaretm.github.io/vee-validate/guide/forms.html#programmatic-access-with-refs
   */
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  mounted() {
    this.$refs.observer;
  }

  async created() {
    this.store.showLoader();

    ///// セレクトボックス制御
    this.queryTypes = this.$t('pages.supportPage.label.select');
    this.queryTypeItems = Object.values(this.queryTypes);

    ///// パラメータ制御
    if (this.$route && this.$route.params) {
      if (this.$route.params.queryType) {
        this.queryType = this.$route.params.queryType;
      }
      if (this.$route.params.queryBody) {
        this.queryBody = this.$route.params.queryBody;
      }
    }
    this.store.hideLoader();
  }

  /**
   * 入力内容確認
   */
  private async confirm() {
    const res = await this.$refs.observer.validate().catch(() => false);
    if (!res) {
      return;
    }

    this.confirmDialog = true;
  }

  /**
   * お問い合わせ登録
   */
  private async register() {
    this.store.showLoader();

    // call Backlog POST issues API
    const description = `${this.$t('pages.supportPage.template.queryBody', [
      this.company != ''
        ? this.company
        : this.$t('pages.supportPage.template.nonInput'),
      this.companyFurigana != ''
        ? this.companyFurigana
        : this.$t('pages.supportPage.template.nonInput'),
      this.lastName,
      this.firstName,
      this.phone,
      this.email,
      this.queryType,
      this.queryBody
    ])}`;
    const requestBody: PostBacklogIssuesRequest = {
      project_id: parseInt(process.env.VUE_APP_BACKLOG_PROJECT_ID),
      assignee_id: parseInt(process.env.VUE_APP_BACKLOG_ASSIGNEE_ID),
      issue_type_id: parseInt(process.env.VUE_APP_BACKLOG_ISSUE_TYPE_ID),
      priority_id: parseInt(process.env.VUE_APP_BACKLOG_PRIORITY_ID),
      summary: `${this.$t('pages.supportPage.template.querySummary', [
        this.queryType,
        this.company != '' ? this.company + ' ' : '',
        this.lastName,
        this.firstName
      ])}`,
      description: description.replace(/\\n/g, '\n')
    };
    const httpClient = await this.$storeCoreClient();
    const err = await httpClient.backlog
      .postBacklogIssues(requestBody)
      .then(() => {
        this.store.addSuccessMessage(
          `${this.$t('pages.supportPage.message.registerIssueSucceed')}`
        );
        return;
      })
      .catch(err => {
        if (err) {
          this.store.addErrorMessage(
            `${this.$t('pages.supportPage.message.registerIssueFailed')}`
          );
        }
        return err;
      });
    if (!err) {
      const requestBody: PostEmailInquiryReplyRequest = {
        to_address: this.email,
        company: this.company,
        name: this.lastName + ' ' + this.firstName,
        phone_number: this.phone,
        inquiry: this.queryType,
        inquiry_detail: this.queryBody
      };
      await httpClient.email.postEmailInquiryReply(requestBody);
      this.$router.back();
    }

    this.store.hideLoader();
    this.confirmDialog = false;
  }
}
